import { createSlice } from '@reduxjs/toolkit';

import { revertAll } from '../actions';

export interface INetworkState {
    isOnline: boolean;
    showOfflineModal: boolean;
}

const initialState: INetworkState = {
    isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
    showOfflineModal: false,
};

const networkSlice = createSlice({
    name: 'network',
    initialState,
    reducers: {
        setOnline: state => {
            state.isOnline = true;
            state.showOfflineModal = false;
        },
        setOffline: state => {
            state.isOnline = false;
            state.showOfflineModal = true;
        },
        closeOfflineModal: state => {
            state.showOfflineModal = false;
        },
    },
    extraReducers: builder => {
        builder.addCase(revertAll, () => initialState);
    },
});

export const { setOnline, setOffline, closeOfflineModal } = networkSlice.actions;
export const networkReducer = networkSlice.reducer;
